// extracted by mini-css-extract-plugin
export default {"content":"WealthDeclaration_content__oVamM","contentTitle":"WealthDeclaration_contentTitle__De5JY","contentValue":"WealthDeclaration_contentValue__+Fu6l"};